import {fetch} from "utils/dataAccess";

export async function getProductsRanking(startDate, endDate, retailers = [], maxResult = 10) {
    const params = new URLSearchParams({ startDate, endDate, maxResult });

    retailers.forEach(r => params.append("retailers[]", r));

    const response = await fetch(`/dashboard/products_ranking_data?${params}`);

    return response.json();
}

export async function getProductsFlops(startDate, endDate, retailers = [], maxResult = 10) {
    const params = new URLSearchParams({ startDate, endDate, maxResult });

    retailers.forEach(r => params.append("retailers[]", r));

    const response = await fetch(`/dashboard/products_flops_data?${params}`);

    return response.json();
}
